module.exports = __webpack_public_path__ + "fonts/Lato-Bold.12a234e8.woff2";